module.exports = __webpack_public_path__ + "static/media/fond-soundbox-fat.f0814af6.jpg";